import { render } from "./SingleCampaign.vue?vue&type=template&id=2d003478"
import script from "./SingleCampaign.vue?vue&type=script&lang=js"
export * from "./SingleCampaign.vue?vue&type=script&lang=js"

import "./SingleCampaign.vue?vue&type=style&index=0&id=2d003478&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__